import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full bg-background-50 py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 border border-accent-300 rounded-full text-accent-700 text-xs md:text-sm font-label tracking-wider mb-4">
            Категории товаров
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-3">
            14 Категорий для Покупок
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto">
            Выберите категорию товаров и перейдите к покупкам через YOYBUY Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:bg-accent-100 hover:border-accent-300 transition-all duration-300"
              data-product-shop
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-background-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-500 group-hover:text-accent-700`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 leading-tight">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-3">{cat.nameEn}</p>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-accent-800 whitespace-nowrap">
                Перейти
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}